import { InputField, TextAreaField, SelectField } from "../common/FormFields";
import { useEffect } from "react";

export default function LetterContentCard({ state, updateState, applicant, errors = {} }) {
  // Auto-fill subject when applicant data is available
  useEffect(() => {
    if (applicant && applicant.role && !state.subject) {
      const autoSubject = `Offer Letter for ${applicant.role} Position`;
      updateState("subject", autoSubject);
    }
  }, [applicant, state.subject, updateState]);
  
  // Handle input changes with proper event handling
  const handleSubjectChange = (e) => {
    const value = e.target.value;
    updateState("subject", value);
  };

  const handleBodyChange = (e) => {
    const value = e.target.value;
    updateState("body", value);
  };

  return (
    <div className="card shadow-sm">
      <div className="card-body p-4">
        <h2 className="card-title fw-bold text-dark mb-4" style={{ fontSize: "18px" }}>
          Letter
        </h2>

        <div className="mb-3">
          <label className="form-label fw-semibold">
            Subject <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className={`form-control ${errors.subject ? 'is-invalid' : ''}`}
            placeholder="e.g., Proposal Submission"
            value={state.subject || ""}
            onChange={handleSubjectChange}
          />
          {errors.subject && (
            <div className="invalid-feedback">
              {errors.subject}
            </div>
          )}
        </div>

        <div className="mb-3">
          <label className="form-label fw-semibold">
            Body <span className="text-danger">*</span>
          </label>
          <textarea
            rows={8}
            className={`form-control font-monospace ${errors.body ? 'is-invalid' : ''}`}
            placeholder="Dear [Recipient], I am writing to..."
            value={state.body || ""}
            onChange={handleBodyChange}
            style={{ resize: 'vertical' }}
          />
          {errors.body && (
            <div className="invalid-feedback">
              {errors.body}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}